/** Mongo ObjectId — what every entity route in this app is keyed by. */
const ENTITY_ID = /^[0-9a-f]{24}$/i;

/**
 * The part of a path that decides whether the reader is still looking at the
 * same thing.
 *
 * Several pages here are one screen with tabs that live in the URL: the visit
 * page (`…/patient/:patientId/notes`, `/history`, `/medications`, …), the
 * patient page, the professional page. Switching those tabs is a pathname
 * change, but not a navigation — the professional is still on the same
 * patient, halfway down the same page, and being thrown back to the top reads
 * as an accidental refresh.
 *
 * The key is the path up to and including its last entity id, so every tab of
 * one patient shares a key while two different patients do not. Paths with no
 * id keep their whole pathname, so ordinary navigation (`/dashboard/treatments`
 * → `/dashboard/statistics`) still counts as a change.
 */
export const scrollContextKey = (pathname: string): string => {
  const segments = pathname.split('/');
  const lastId = segments.reduce(
    (found, segment, index) => (ENTITY_ID.test(segment) ? index : found),
    -1,
  );
  return lastId === -1 ? pathname : segments.slice(0, lastId + 1).join('/');
};

export default scrollContextKey;
